/*global VeloxDatabaseClient*/

module.exports.SYNC_STRATEGY_READONLY = {
    before: function(context, callback){ callback() ;},
    after: function(context, callback){ 
        localStorage.setItem(context.currentUser.login+"_velox_offline_changes", "[]") ;
        callback() ;
    }
} ;

module.exports.resyncAll = function(api, callback){
    var searches = {} ;
    var tables = [
        "reseller_settings",
        "saved_search",
        "customer",
        "doc",
        "visit",
        "spa",
        "pool",
        "diag",
        "diag_custom_product"
    ] ;
    tables.forEach(function(tableName){
        searches[tableName] = {search: {}} ;
    }) ;
    VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_MANUAL) ;
    api.api.multiread(searches, function(err, reads){
        if(err){ return callback(err) ;}
        var changes = [] ;
        reads.doc = reads.doc.filter(d=>{
            return reads.customer.some(c=>c.c_id ===d.c_id)
        }) ;
        reads.visit = reads.visit.filter(d=>{
            return reads.customer.some(c=>c.c_id ===d.c_id)
        }) ;
        reads.diag = reads.diag.filter(d=>{
            return reads.customer.some(c=>c.c_id ===d.c_id)
        }) ;
        tables.forEach(function(tableName){
            var records = reads[tableName] ;
            records.forEach(function(record){
                changes.push({
                    table: tableName,
                    record: record
                }) ;
            }) ;
        }) ;
        let modifPacks = [] ;
        let currentPack = [] ;
        modifPacks.push(currentPack) ;
        for(let i=0;i<changes.length; i++){
            currentPack.push(changes[i]) ;
            if(currentPack.length>=1000){
                currentPack = [] ;
                modifPacks.push(currentPack) ;
            }
        }
        VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_ALWAYS) ;
        let calls = [] ;
        for(let changes of modifPacks){
            calls.push((cb)=>{
                api.api.transactionalChanges(changes, cb) ;
            })
        }
        VeloxWebView._asyncSeries(calls, callback) ;
    }) ;
} ;